module.exports = __webpack_public_path__ + "static/media/36x36-0.63e2b59b.png";